import './styles.scss';

export default {
    name: 'FreehandModeDropdown',
    
    data() {
        return  {
            lineThickness: '5',
            primaryColor: '#FF0000',
        };
    },

    methods: {
        chooseColor(color) {
            this.primaryColor = color;

            this.$ionic.popoverController.dismiss({ 
                lineThickness: this.lineThickness,
                primaryColor: this.primaryColor 
            });
        },
        
        chooseLineThickness(thickness) {
            this.lineThickness = thickness;

            this.$ionic.popoverController.dismiss({ 
                lineThickness: this.lineThickness,
                primaryColor: this.primaryColor 
            });
        }
    }
};